var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 22,
    viewBox: "0 0 31 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2184 19.822C20.2184 21.0304 19.2488 22 18.0404 22C16.832 22 15.8528 21.0304 15.8528 19.822C15.8528 18.6135 16.8367 17.6344 18.0404 17.6344C19.2536 17.6344 20.2184 18.6135 20.2184 19.822ZM8.09119 17.6344C6.88276 17.6344 5.91316 18.6183 5.91316 19.822C5.91316 21.0256 6.88276 22 8.09119 22C9.29961 22 10.2788 21.0304 10.2788 19.822C10.2788 18.6135 9.29961 17.6344 8.09119 17.6344ZM22.0239 4.73817C7.58967 4.73817 3.91185 4.12679 0 0C1.64307 2.46939 2.54581 7.11203 17.8207 6.88754C33.7403 6.64872 24.03 11 21.2023 15.9101C30.1198 7.94789 36.4581 4.73817 22.0239 4.73817Z",
    fill: "#F4F6F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartWhite);
export default __webpack_public_path__ + "static/media/cartWhite.0f7a4164808078bf67e259db0e994eba.svg";
export { ForwardRef as ReactComponent };